import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "c-eyecatch c-eyecatch--email" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-eyecatch__img" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "p-mypage__ttl c-ttl" }, "メールアドレス 変更", -1)
const _hoisted_3 = { class: "p-mypage__sec" }
const _hoisted_4 = { class: "p-mypage__field-container" }
const _hoisted_5 = { class: "p-fields p-fields--confirm" }
const _hoisted_6 = { class: "c-field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "現在のメールアドレス", -1)
const _hoisted_8 = { class: "c-field__body" }
const _hoisted_9 = { class: "p-errors" }
const _hoisted_10 = { class: "c-error" }
const _hoisted_11 = { class: "p-fields" }
const _hoisted_12 = { class: "c-field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "newEmail"
}, [
  /*#__PURE__*/_createTextVNode("新しいメールアドレス"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_14 = { class: "c-field__body" }
const _hoisted_15 = { class: "c-field__input" }
const _hoisted_16 = { class: "c-field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "newEmailRetype"
}, [
  /*#__PURE__*/_createTextVNode("新しいメールアドレス(確認)"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_18 = { class: "c-field__body" }
const _hoisted_19 = { class: "c-field__input" }
const _hoisted_20 = { class: "c-field has-submit has-mt" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "入力内容を確認する", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "戻る", -1)
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_component_Form, {
        onSubmit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.changeEmail, this))),
        "validation-schema": _ctx.schema
      }, {
        default: _withCtx(({ errors, meta }) => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("fieldset", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.currentEmailRef), 1)
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.errorMsgRef), 1)
            ], 512), [
              [_vShow, _ctx.errorMsgRef]
            ]),
            _createElementVNode("fieldset", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_Field, {
                      type: "text",
                      id: "newEmail",
                      name: "newEmail",
                      modelValue: _ctx.newEmailRef,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newEmailRef) = $event)),
                      placeholder: "○○○○○○○○",
                      required: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.newEmail), 513), [
                [_vShow, errors.newEmail]
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Field, {
                      type: "text",
                      id: "newEmailRetype",
                      name: "newEmailRetype",
                      modelValue: _ctx.newEmailRetypeRef,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newEmailRetypeRef) = $event)),
                      placeholder: "○○○○○○○○",
                      required: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.newEmailRetype), 513), [
                [_vShow, errors.newEmailRetype]
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "c-btn is-submit",
                  disabled: !meta.valid || _ctx.isDeterringRef
                }, _hoisted_23, 8, _hoisted_21),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["c-btn c-btn--outline", { 'is-disabled':_ctx.isDeterringRef }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push({ name: 'MypageTop' })))
                }, _hoisted_25, 2)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ], 64))
}